import { Component, OnInit, Input, Output, ViewChild, ElementRef, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { fromEvent } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { AppWindow } from './model/app-window';
import { SpeechRecognizerService } from './services/speech-recognizer.service';
import { SpeechError } from './model/speech-error';
import { SpeechNotification } from './model/speech-notification';
const myWindow: AppWindow = (window as any) as AppWindow;

@Component({
  selector: 'app-web-speech',
  templateUrl: './web-speech.component.html',
  styleUrls: ['./web-speech.component.css']
})
export class WebSpeechComponent implements OnInit {

  @Input() answer;
  @Input() _element;

  @Output() onFocusOut = new EventEmitter<any>();
  @Output() textValue = new EventEmitter<any>();

  @ViewChild('textBox', {static: true}) textBox: ElementRef;

  words: number = 1;
  speechSupported = false;
  recognizing = false;
  finalTranscript = '';
  notification: string;
  placeholder = 'Type Here...'
  listening = false;
  languages: string[] = ['en-US', 'es-ES'];
  currentLanguage: string;


  constructor(private changeDetector: ChangeDetectorRef,
    private speechRecognizer: SpeechRecognizerService) { }

  ngOnInit() {
    if (!('webkitSpeechRecognition' in window)) {
      this.speechSupported = false;
    } else {
      this.speechSupported = true;
      this.currentLanguage = this.languages[0];
      this.speechRecognizer.initialize(this.currentLanguage);
      this.initRecognition();
      this.notification = null;
    }

    if(this.textBox) {
      const keyup$ = fromEvent<any>(this.textBox.nativeElement, 'input');
      keyup$
      .pipe(
        map((i: any) => i.currentTarget.value),
        debounceTime(500)
        )
        .subscribe((i) => {
          this.textValue.emit(i);
        });
    }
  }

  onInput(value) {
    if (value) {
      this.words = value.match(/\S+/g).length;
      if (this.words > this._element.wordLimit) {
        let trimmed = this.answer.split(/\s+/, this._element.wordLimit).join(" ");
        this.answer = trimmed + " ";
      }
    }
  }

  startListening(event) {
    if (this.recognizing) {
      this.speechRecognizer.stop();
      return;
    }

    this.speechRecognizer.start(event.timeStamp);
  }

  private initRecognition() {
    this.speechRecognizer.onStart()
      .subscribe(data => {
        this.recognizing = true;
        this.notification = null;
        this.placeholder = 'Speak Now...';
        this.listening = true;
        this.detectChanges();
      });

    this.speechRecognizer.onEnd()
      .subscribe(data => {
        this.recognizing = false;
        this.detectChanges();
        this.notification = null;
        this.placeholder = 'Type Here...';
        this.listening = false;
      });

    this.speechRecognizer.onResult()
      .subscribe((data: SpeechNotification) => {
        const message = data.content.trim();
        if (data.info === 'final_transcript' && message.length > 0) {
          if (!this.answer) {
            this.answer = '';
          }
          this.finalTranscript = `${this.finalTranscript}${message}`;
          this.answer = `${this.answer} ${message}`;
          this.textValue.emit(this.answer);
          this.detectChanges();
        }
      });

    this.speechRecognizer.onError()
      .subscribe(data => {
        switch (data.error) {
          case SpeechError.BLOCKED:
          case SpeechError.NOT_ALLOWED:
            this.notification = `Cannot run the demo.
            Your browser is not authorized to access your microphone. Verify that your browser has access to your microphone and try again.
            `;
            break;
          case SpeechError.NO_SPEECH:
            this.notification = `No speech has been detected. Please try again.`;
            break;
          case SpeechError.NO_MICROPHONE:
            this.notification = `Microphone is not available. Plese verify the connection of your microphone and try again.`;
            break;
          default:
            this.notification = null;
            break;
        }
        this.listening = false;
        this.recognizing = false;
        this.detectChanges();
      });
  }

  detectChanges() {
    this.changeDetector.detectChanges();
  }
}
